import * as yup from "yup";
import { MSG } from "../constants/MSG";

export const moodSchema = yup.object().shape({
	label: yup
		.string()
		.trim()
		.matches(/^[a-zA-Z0-9_ ]*$/, MSG.PROVIDE_VALID_MOOD_LABEL)
		.max(15, MSG.MAX_MOOD_LABEL)
		.required(MSG.REQUIRED_MOOD_LABEL),
	is_active: yup.object().required(MSG.REQUIRED_STATUS),
	emoji: yup.string().required(MSG.REQUIRED_EMOJI),
});
